/**
* @description 查询树形叶子节点是否存在某个数据
* @param { keyValue }  parentNode 当前需要查询的字段与值 { key: string, value:string | number }
* @param {Array<object>} dataTree 树原数据
* @param { String } childNode  子节点字段名称  默认为children
* @return {Boolean} 是否存在  true 存在  false 不存在
*/
export const childIsLoded = (parentNode , dataTree, childNode = 'children') => { 
    if(dataTree.find((item)=> (item[parentNode.key] && item[parentNode.key] == parentNode.value &&  item[childNode]))){
        return true
    }else{
        if(dataTree.length <= 0){
            return false
        }else{
            let childNodeRect =  dataTree.map(item => item[childNode]).filter(item => item != undefined)
            //合并数组
            return  childIsLoded(parentNode, childNodeRect.flat())
        }
    }
}


/**
* @description 增加叶子节点并返回新树
* @param { keyValue }  parentNode 当前需要删除的父节点 { key: string, value:string | number }
* @param {Array<object>} dataTree 树原数据
* @param {object} operational  需要插入的数据 
* @param { String } childNode  子节点字段名称  默认为children
* @return {Array<object>} 返回新树
*/
export const addChildrenNode = (parentNode, dataTree, operational , childNode = 'children') => { 
    let newTreeNode = []
    dataTree.forEach((item)=> {
            if(item[parentNode.key] == parentNode.value){
                item[childNode].unshift(operational)
                newTreeNode.unshift(item)
            }else{
                if(!item[childNode] ||item[childNode].length <= 0){
                    newTreeNode.push(item)
                }else{
                    addChildrenNode(parentNode, item[childNode], operational)
                    newTreeNode.push(item)
                }
            }
    })
    return newTreeNode
}

/**
* @description 删除叶子节点并返回新树
* @param {String | Number}  parentNode 当前需要删除的父节点 {key: string, value:string | number}
* @param {Array<object>} dataTree 树原数据
* @param {keyValue} nowNode 当前需要删除的子节点 {key: string, value:string | number}
* @param { String } childNode  子节点字段名称
* @return {Array<object>} 返回新树
*/

export const delectChildrenNode = (parentNode, dataTree, nowNode,  childNode = 'children') => { 
    let newTreeNode = []
    dataTree.forEach((item)=> {
            if(item[parentNode.key] == parentNode.value){
                item[childNode] = item[childNode].filter((filterItem) => filterItem[nowNode.key] != nowNode.value)
                newTreeNode.push(item)
            }else{
                if(!item[childNode] ||item[childNode].length <= 0){
                    newTreeNode.push(item)
                }else{
                    delectChildrenNode(parentNode, item[childNode], nowNode)
                    newTreeNode.push(item)
                }
            }
    })
    return newTreeNode
}



export const addChildrenKey = (dataTree, childNode = 'children') => { 
    let newTreeNode = []
    dataTree.forEach((item)=> {
        item.meta = {
            title: item.title,
            icon: item.icon ? item.icon : " "  
        }
        if(!item[childNode] ||item[childNode].length <= 0){
            delete item[childNode]
            newTreeNode.push(item)
        }else{
            addChildrenKey(item[childNode], childNode)
            newTreeNode.push(item)
        }
    })
    return newTreeNode
}